// extracted by mini-css-extract-plugin
export default {"orderby":"OrderBy_orderby__2CbSM","content":"OrderBy_content__E7AIz","title":"OrderBy_title__AymRI"};